<template>
  <g ref="axis">
  </g>
</template>

<script>
import * as d3 from 'd3'

const props = {
  position: {
    type: String,
    required: true

  },
  scaled: {
    required: true
  },
  tickFormat: {
    type: String,
    default: 'number'
  },
  tickValue: {
    type: String,
    default: null
  },
  translateX: {
    type: Number,
    default: 0
  },
  translateY: {
    type: Number,
    default: 0
  }
}

export default {
  name: 'd3-axis',
  props,
  watch: {
    $props: {
      handler () {
        this.update()
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      defaultFormats: {
        date: '%B %d, %Y',
        number: 'd'
      }
    }
  },
  mounted () {
    this.update()
  },
  methods: {
    update () {
      let $this = this

      if (this.scaled && this.position) {
        // GET RID OF THIS IF IT EXISTS FOR REDRAW
        d3.select(this.$refs.axis).select('g').remove()

        let axisFunction = 'axisBottom'
        switch (this.position) {
          case 'left':
            axisFunction = 'axisLeft'
            break
        }

        let tickFunction = 'format'

        switch (this.tickFormat) {
          case 'number':
            tickFunction = 'format'
            break
          case 'date':
            tickFunction = 'timeFormat'
        }

        let tickFunctionValue = this.tickValue
        if (!tickFunctionValue) {
          tickFunctionValue = this.defaultFormats[this.tickFormat]
        }

        let axisCall = d3[axisFunction](this.scaled).tickFormat(d3[tickFunction](tickFunctionValue))

        // Set Number of Ticks
        switch (this.tickFormat) {
          case 'number':
            if (this.scaled.domain()[1] - this.scaled.domain()[0] < 10) {
              axisCall.ticks(this.scaled.domain()[1] - this.scaled.domain()[0])
            }
            break
          case 'date':
            axisCall.ticks(4)
            break
        }

        let axis = d3.select(this.$refs.axis)
        axis.append('g')
          .attr('id', 'axis-' + $this._uid)
          .attr('class', 'axis')
          .attr('transform', 'translate(' + $this.translateX + ', ' + $this.translateY + ')')
          .call(axisCall)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';
  .axis {
    stroke: $brandGreen;
    path {
      stroke: $brandGreen;
    }
  }
  .tick {
    line, text {
      stroke: $brandSalmon25;
      font-family: sans-serif;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/d3/Axis.vue